<template>
  <div class="video-preview">
    <el-dialog
      title=""
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div>
        <video-box ref="videoBoxItem" :src="src" :poster="poster"></video-box>
      </div>
      <span slot="footer">
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
import videoBox from '../videoBox'
export default {
  name: 'videoPreview',
  components: { videoBox },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    src:{
      type: String,
      default: ''
    },
    poster:{
      type:String,
      default: '',
    }
  },
  data() {
    return {}
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) this.$nextTick(() => {
          if (this.$refs.videoBoxItem.videoLoadingStatus) this.$refs.videoBoxItem.playVideo()
        })
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
      if (this.$refs.videoBoxItem.videoPayStatus) this.$refs.videoBoxItem.pauseVideo()
    }
  }
}
</script>

<style lang="scss" scoped>
.video-preview /deep/ .el-dialog__footer {
  display: none;
}
</style>


// WEBPACK FOOTER //
// common/videoPreview/index.vue